import React, { Component } from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { getAuthenticated } from 'views/auth/_reducers';
import { Nav, NavItem, Navbar } from 'reactstrap';
import SvgRender from 'components/helpers/SvgRender';

import settings from 'assets/svg/settings.svg';
import logo from 'assets/svg/notext_logo.svg';
import users from 'assets/svg/user.svg';
import channels from 'assets/svg/channels.svg';

const menus = [
  {
    icon: channels,
    to: '/channels',
    height: 22,
    width: 29
  },
  {
    icon: users,
    to: '/users',
    admin: true,
    height: 22,
    width: 23
  }
  // {
  //   icon: settings,
  //   to: '/settings',
  //   height: 22,
  //   width: 22
  // }
];

class Sidebar extends Component {
  render() {
    return (
      <div className="sidebar public-hide">
        <Navbar className="px-0">
          <Nav vertical>
            <NavItem className="left-navbar-brand">
              <NavLink activeClassName="active-logo" to={'/'}>
                <SvgRender path={logo} style={{ width: 58 }} />
              </NavLink>
            </NavItem>

            {menus.map((menu, i) =>
              !menu.admin || (menu.admin && this.props.account.superadmin) ? (
                <NavItem key={i}>
                  <NavLink to={menu.to} tag="li" className="reverse">
                    <SvgRender
                      path={menu.icon}
                      style={{ height: menu.height, width: menu.width }}
                    />
                  </NavLink>
                </NavItem>
              ) : null
            )}
          </Nav>
        </Navbar>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authenticated: getAuthenticated(state),
    account: state.account
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    {}
  )(Sidebar)
);



// WEBPACK FOOTER //
// ./src/components/layouts/Sidebar.js